import { createStyles, makeStyles, Theme, Typography, TypographyProps } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

import { textSizes, TextSizesEnum } from '../../../theme';

interface Props {
  text?: string | number | null;
  size: TextSizesEnum;
  className?: string;
  children?: React.ReactNode;
  maxLine?: number;
}

export type PlexTypographyProps = Props & TypographyProps;

export const PlexTypography = React.memo(
  React.forwardRef(
    (props: PlexTypographyProps, ref: React.Ref<HTMLSpanElement>): React.ReactElement => {
      // we need to extract `size` so we don't pass it with `{...other}` to the typography types
      const { className, text, children, size, maxLine, ...other } = props;
      const classes = useStyles(props);
      const content = text || children;
      if (typeof content === 'string' || typeof content === 'number') {
        return (
          <Typography className={classNames(classes.root, className)} {...other} ref={ref}>
            {content}
          </Typography>
        );
      }
      return (
        <span className={classNames(classes.root, className)} {...other} ref={ref}>
          {content}
        </span>
      );
    }
  )
);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: ({ size = TextSizesEnum.Normal, maxLine }: Props) => ({
      display: 'flex',
      whiteSpace: 'pre-line',
      fontSize: textSizes[size].fontSize,
      lineHeight: textSizes[size].lineHeight,
      fontWeight: 500,
      wordBreak: 'break-word',
      fontFamily: 'Inter',
      textAlign: 'left',
      ...(maxLine != null
        ? {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            '-webkit-line-clamp': maxLine,
            '-webkit-box-orient': 'vertical',
          }
        : {}),
    }),
  })
);
